import api from './api';

export const getPickupShops = (parcelCode: string) =>
  api.get({
    path: `/parcels/${parcelCode}/pickupLocations`,
  });
